import { accBankEn } from "./parts/accBank";
import { accDocumentsEn } from "./parts/accDocuments";
import { accInboxEn } from "./parts/accInbox";
import { accLedgerEn } from "./parts/accLedger";
import { accOverviewEn } from "./parts/accOverview";
import { accVatContactsEn } from "./parts/accVatContacts";
import { agentTabsEn } from "./parts/agentTabs";
import { agentWorkEn } from "./parts/agentWork";
import { agentsEn } from "./parts/agents";
import { alertsEn } from "./parts/alerts";
import { analysisMessagesEn } from "./parts/analysisMessages";
import { analysisQueueEn } from "./parts/analysisQueue";
import { analysisToolsEn } from "./parts/analysisTools";
import { billingEn } from "./parts/billing";
import { customersEn } from "./parts/customers";
import { decisionsEn } from "./parts/decisions";
import { flowDiagnosisEn } from "./parts/flowDiagnosis";
import { ideasEn } from "./parts/ideas";
import { miscBEn } from "./parts/miscB";
import { multiSelectEn } from "./parts/multiSelect";
import { myEn } from "./parts/my";
import { profileEn } from "./parts/profile";
import { projNewEn } from "./parts/projNew";
import { projOverviewEn } from "./parts/projOverview";
import { projReviewEn } from "./parts/projReview";
import { projSetEn } from "./parts/projSet";
import { projTabsEn } from "./parts/projTabs";
import { projVisionEn } from "./parts/projVision";
import { relEn } from "./parts/releases";
import { reportsEn } from "./parts/reports";
import { shellEn } from "./parts/shell";
import { sugEn } from "./parts/suggestions";
import { syncEn } from "./parts/sync";
import { timeEntriesEn } from "./parts/timeEntries";
import { usersEn } from "./parts/users";
import { wiBulkEn } from "./parts/wiBulk";
import { wiDetailEn } from "./parts/wiDetail";
import { wiNewEn } from "./parts/wiNew";
import { wikiEn } from "./parts/wiki";
import { workItemDetailEn } from "./parts/workItemDetail";
import { workItemListEn } from "./parts/workItemList";

/**
 * English strings — the source of truth and the fallback for every key a
 * language doesn't have yet. Screens move over to `t()` module by module;
 * what hasn't moved is still English text in the JSX.
 *
 * Another language = a file like `cs.ts` plus an entry in `lib/i18n.ts`.
 */
export const en = {
  ...shellEn,
  ...workItemListEn,
  ...workItemDetailEn,
  ...accBankEn,
  ...accDocumentsEn,
  ...accInboxEn,
  ...accLedgerEn,
  ...accOverviewEn,
  ...accVatContactsEn,
  ...agentsEn,
  ...flowDiagnosisEn,
  ...agentTabsEn,
  ...agentWorkEn,
  ...alertsEn,
  ...analysisQueueEn,
  ...analysisToolsEn,
  ...multiSelectEn,
  ...analysisMessagesEn,
  ...billingEn,
  ...customersEn,
  ...myEn,
  ...decisionsEn,
  ...timeEntriesEn,
  ...projReviewEn,
  ...projOverviewEn,
  ...projNewEn,
  ...projTabsEn,
  ...projVisionEn,
  ...projSetEn,
  ...wiBulkEn,
  ...wiDetailEn,
  ...wiNewEn,
  ...relEn,
  ...wikiEn,
  ...ideasEn,
  ...sugEn,
  ...syncEn,
  ...reportsEn,
  ...profileEn,
  ...usersEn,
  ...miscBEn,
  langFormat: {
    cardTitle: "Language and format",
    cardDescription:
      "Language and the date and number format are saved to your account and apply on every device.",
    language: "Language",
    languageCs: "Čeština",
    languageEn: "English",
    format: "Date and number format",
    formatCs: "Czech ({{example}})",
    formatEn: "English ({{example}})",
    saveFailed: "Couldn't save the setting",
  },
  nav: {
    profileSettings: "Profile settings",
    signOut: "Sign out",
  },
  userSettings: {
    language: "Language",
    format: "Date and number format",
    followLanguage: "Follow the language",
    notSet: "Not chosen (browser / Czech in e-mails)",
  },
};

export type Translation = typeof en;
